module.exports = new __parcel__URL__("error-state-dark.6e485691.svg").toString();